<template>
	<div class="verify-ach-dialog">
		<header class="verify-heading">
			<span class="verify-icon" aria-hidden="true">
				<portal-icon name="circle-check" :size="21"></portal-icon>
			</span>
			<h2>{{ $t('invoices.verify-ach-account.enter-verification') }}</h2>
			<button type="button" class="dialog-close" :aria-label="$t('global.close')" @click="handleClose">
				<portal-icon name="x" :size="19"></portal-icon>
			</button>
		</header>

		<div class="verify-body">
			<v-form ref="accountForm" class="deposit-grid" @submit.prevent v-model="isValid">
				<v-text-field
					v-model="amount1"
					:label="$t('invoices.verify-ach-account.enter-deposit-1')"
					hide-details
					maxlength="2"
					prefix="$0."
					:rules="requiredRules"
					persistent-placeholder
					class="portal-form-field"
				></v-text-field>
				<v-text-field
					v-model="amount2"
					:label="$t('invoices.verify-ach-account.enter-deposit-2')"
					hide-details
					maxlength="2"
					prefix="$0."
					:rules="requiredRules"
					persistent-placeholder
					class="portal-form-field"
				></v-text-field>
			</v-form>
		</div>

		<footer class="verify-footer">
			<button type="button" class="dialog-action outline" @click="handleClose">
				{{ $t('global.cancel') }}
			</button>
			<button type="button" class="dialog-action primary" @click="verifyAccount" :disabled="!isValid">
				{{ $t('global.verify') }}
			</button>
		</footer>
	</div>
</template>

<script>
	import PaymentsService from '@/modules/invoices/PaymentsService';
	import ConfirmModal from '@/components/ConfirmModal';
	import PortalIcon from '@/components/PortalIcon.vue';

	export default {
		name: 'VerifyAchAccount',

		props: ['bankAccount'],

		components: { PortalIcon },

		data: function() {
			return {
				amount1: null,
				amount2: null,
				paymentsService: new PaymentsService(),
				isValid: false,

				requiredRules: [(v) => !!v || 'Required'],
			};
		},

		mounted() {},

		beforeDestroy() {},

		methods: {
			handleError: function(message) {
				this.$store.commit('stopLoading');

				let binding = {
					headingText: this.$t('error.connecting-account'),
					bodyText: message,
					hideNo: true,
					yesText: this.$t('global.okay'),
				};
				this.$store.state.globalModalController.openModal(ConfirmModal, binding, true, false);
			},

			verifyAccount: function() {
        this.$store.commit('startLoading');
				this.paymentsService
					.verifyBankAccount(this.bankAccount.id, this.amount1, this.amount2)
					.then((res) => {
            this.$store.commit('stopLoading');
						this.$emit('result',res.data);
					})
					.catch((err) => {
						this.handleError(err.response.data.message);
					});
			},

			handleClose() {
				this.$emit('result', false);
			},
		},

		computed: {},
	};
</script>

<style scoped lang="scss">
	.verify-ach-dialog {
		width: min(520px, calc(100vw - 32px));
		overflow: hidden;
		border-radius: var(--brand-surface-radius, 18px);
		background: var(--portal-surface);
	}

	.verify-heading {
		min-height: 68px;
		display: flex;
		align-items: center;
		gap: 11px;
		padding: 14px 18px;
		border-bottom: 1px solid var(--portal-border);
	}

	.verify-heading h2 {
		min-width: 0;
		flex: 1;
		margin: 0;
		color: var(--portal-text);
		font-size: 17px;
		font-weight: 650;
		text-align: left;
	}

	.verify-icon,
	.dialog-close {
		display: grid;
		place-items: center;
		border-radius: 11px;
	}

	.verify-icon {
		width: 38px;
		height: 38px;
		background: var(--v-success_10-base);
		color: var(--v-success-base);
	}

	.dialog-close {
		width: 36px;
		height: 36px;
		border: 0;
		background: transparent;
		color: var(--portal-muted);
		cursor: pointer;
	}

	.verify-body {
		padding: 20px;
	}

	.deposit-grid {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: 12px;
	}

	.portal-form-field {
		margin: 0;
		padding: 0;
	}

	.portal-form-field ::v-deep .v-input__slot {
		min-height: 54px;
		margin: 0;
		padding: 0 13px !important;
		border: 1px solid var(--portal-border) !important;
		border-radius: var(--brand-field-radius, 11px) !important;
		background: var(--portal-surface) !important;
		box-shadow: none !important;
	}

	.portal-form-field ::v-deep .v-input__slot::before,
	.portal-form-field ::v-deep .v-input__slot::after {
		display: none !important;
	}

	.verify-footer {
		display: flex;
		justify-content: flex-end;
		gap: 9px;
		padding: 14px 18px;
		border-top: 1px solid var(--portal-border);
	}

	.dialog-action {
		min-height: 42px;
		padding: 0 16px;
		border: 1px solid var(--portal-border);
		border-radius: var(--brand-button-radius, 11px);
		font: inherit;
		font-size: 13px;
		font-weight: 650;
		cursor: pointer;
	}

	.dialog-action.outline {
		background: var(--portal-surface);
		color: var(--portal-text);
	}

	.dialog-action.primary {
		border-color: var(--v-primary-base);
		background: var(--v-primary-base);
		color: var(--v-white-base);
	}

	.dialog-action:disabled {
		opacity: 0.45;
		cursor: not-allowed;
	}

	@media (max-width: 479px) {
		.deposit-grid {
			grid-template-columns: 1fr;
		}
	}
</style>
